import ColoredScopes from './ColoredScopes';

export default {
  __init__: [
    'coloredScopes'
  ],
  coloredScopes: [ 'type', ColoredScopes ]
};